// extracted by mini-css-extract-plugin
export default {"block":"CreateOrganizationArtistsBlock_block__+GYWR","block__title":"CreateOrganizationArtistsBlock_block__title__DPsEw"};